import React from 'react';
import Nav from '../MEP/SWNav';
import FooterSW from '../MEP/footer_SW';
import mail from '../../assets/Icones/mail-vert.png';
import tel from '../../assets/Icones/tel-vert.png';
import loca from '../../assets/Icones/pin-localisation-verte.png';


function NousContacter() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Nav />

      <div className="contact-hero">
        <h1 className="contact-titre">Contactez-nous</h1>
        <div className="contact-separateur" />
        <p className="contact-sous-titre">
          Une question sur vos diagnostics climatiques ? Nous sommes là.
        </p>
      </div>

      <div className="contact-body">
        <div className="contact-cards">

          <a href="tel:+33685480187" className="contact-card">
            <div className="contact-icon-wrapper">
              <img src={tel} alt="telephone" className="contact-icon" />
            </div>
            <span className="contact-label paragraphe">TELEPHONE</span>
            <span className="contact-value paragraphe">+33(0)6.85.48.01.87</span>
          </a>

          <a href="mailto:contact@diagorisk.com" className="contact-card">
            <div className="contact-icon-wrapper">
              <img src={mail} alt="email" className="contact-icon" />
            </div>
            <span className="contact-label paragraphe">EMAIL</span>
            <span className="contact-value paragraphe">contact@diagorisk.com</span>
          </a>

          <a href="https://maps.google.com/?q=5+rue+Petrelle+75009+Paris" target="_blank" rel="noopener noreferrer" className="contact-card">
            <div className="contact-icon-wrapper">
              <img src={loca} alt="adresse" className="contact-icon" />
            </div>
            <span className="contact-label paragraphe">ADRESSE</span>
            <span className="contact-value paragraphe">25 rue Petrelle<br />75009 Paris</span>
          </a>

        </div>
      </div>

      <FooterSW />
    </div>
  );
}

export default NousContacter;